import { atom } from "recoil";
import { ACTION_EDIT_DEFAULT } from "../../common/constants";

export const actionEditState = atom({
  key: "actionEditState",
  default: { ...ACTION_EDIT_DEFAULT },
});
